var render, staticRenderFns
import script from "./OrsTimeline.vue?vue&type=script&lang=js&"
export * from "./OrsTimeline.vue?vue&type=script&lang=js&"
import style0 from "./OrsTimeline.vue?vue&type=style&index=0&id=66d36ba1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d36ba1",
  null
  
)

export default component.exports